import _ from "lodash";
import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { formatMobileNumber } from "@/utils/formInputUtils";

import "../style.scss";

const makeAssociationRow = (association, index) => {
  const fullName = `${association.first_name} ${association.last_name}`;

  return (
    <tr key={association.id || `${association.first_name}-${association.last_name}-${index}`}>
      <td className="FamilyMemberWidget__name_column">
        <p className="FamilyMemberWidget__name_column_offset" data-private>
          {fullName}
        </p>
      </td>
      <td className="FamilyMemberWidget__email_column">{`${association.email}`}</td>
      <th className="FamilyMemberWidget__phone_column">{formatMobileNumber(association.mobile)}</th>
      <td className="FamilyMemberWidget__relationship_column">{`${association.relationship_type}`}</td>
    </tr>
  );
};

const makeHeader = () => {
  return (
    <tr>
      <th className="FamilyMemberWidget__name_column">
        <p className="FamilyMemberWidget__name_column_offset">Name</p>
      </th>
      <th className="FamilyMemberWidget__email_column">Email</th>
      <th className="FamilyMemberWidget__phone_column">Phone</th>
      <th className="FamilyMemberWidget__relationship_column">Relationship</th>
    </tr>
  );
};

const enumerateFamilyMembers = (associations) => {
  return (
    <table className="table table-sm">
      <thead className="FamilyMemberWidget__table_header">{makeHeader()}</thead>
      <tbody>
        {associations.map((association, index) => makeAssociationRow(association, index))}
      </tbody>
    </table>
  );
};

const FamilyMembersWidget = (props) => {
  const { patientDetails } = props;

  const associatedGuardians = patientDetails.enriched_associated_guardians;
  const associatedWards = patientDetails.enriched_associated_wards;

  const combinedAssociations = associatedGuardians.concat(associatedWards);

  if (_.isEmpty(combinedAssociations)) {
    // TODO: Should we show the family section if there are no associated entities?
    return <></>;
  }

  return (
    <DashboardCard2 title="Family Members">
      <div className="dashboard-widget-card dashboard-widget-card">
        {enumerateFamilyMembers(combinedAssociations, props)}
      </div>
    </DashboardCard2>
  );
};

export default FamilyMembersWidget;
